// ! This file was auto-generated from the unified-fields OpenAPI schema. Do not override this file.
export const Tags = {
    Client_Field_Overrides: "Client Field Overrides",
    Client_Fields: "Client Fields",
    ClientField: "ClientField",
    ClientFieldOverride: "ClientFieldOverride",
    Field_Lookup_Table_Cells: "Field Lookup Table Cells",
    Field_Lookup_Table_Columns: "Field Lookup Table Columns",
    Field_Lookup_Table_Rows: "Field Lookup Table Rows",
    Field_Lookup_Tables: "Field Lookup Tables",
    Field_Options: "Field Options",
    Field_Sections: "Field Sections",
    Field_Suggestions: "Field Suggestions",
    Field_Usage: "Field Usage",
    FieldLookupTable: "FieldLookupTable",
    FieldLookupTableCell: "FieldLookupTableCell",
    FieldLookupTableColumn: "FieldLookupTableColumn",
    FieldLookupTableRow: "FieldLookupTableRow",
    FieldOption: "FieldOption",
    FieldSection: "FieldSection",
    Healthchecks: "Healthchecks",
    Option_Sets: "Option Sets",
    OptionSet: "OptionSet"
} as const;
export type TagName = (typeof Tags)[keyof typeof Tags];
